module.exports = __webpack_public_path__ + "img/totalUnitCost.5bf5a696.png";